import { ready } from './utils'
import ariaSetter from './modules/ariasetter'
import productPreview from './modules/product-preview'
import menuAttributeSetter from './modules/menu-attribute-setter'
import cartCookieSetter from './modules/cart-cookie-setter'
import collapsibleToggle from './modules/collapsible-toggle'

ready(ariaSetter())

ready(productPreview())
ready(menuAttributeSetter())
ready(cartCookieSetter())
ready(collapsibleToggle())